<template>
  <div class="instant-search__input">

    <input
      v-model="query"
      @keyup="search($event)"
      ref="input"
      class="instant-search__input"
      type="search"
      name="q"
      id="Search"
      autocomplete="off">

    <div class="instant-search__results" v-if="$store.searchActive && all_empty == false">

      <section class="results-group suggestions" v-if="suggestions.length">
        <div class="results-group__header">
          <span>Suggestions</span>
        </div>
        <ul class="result-group__ul">
          <li
            class="result-group__li"
            v-for="(suggestion, idx) in suggestions"
            :key="idx"
            @click="searchSuggestion(suggestion)">
            {{ suggestion }}
          </li>
        </ul>
      </section>

      <section class="results-group pages" v-if="pages.length">
        <div class="results-group__header">
          <span>Pages</span>
        </div>
        <ul class="result-group__ul">
          <li class="result-group__li" v-for="(page, idx) in pages" :key="idx">
            <a :href="page.url">
              {{ page.title }}
            </a>
          </li>
        </ul>
      </section>

      <section class="results-group products" v-if="products.length">
        <div class="results-group__header">
          <span>Products</span>
        </div>
        <ul class="result-group__ul">
          <li class="result-group__li" v-for="(product, idx) in products" :key="idx">
            <a class="product-item__link result-product" :href="`/collections/${ handle }/products/${ product.handle }`">
              <!-- Image -->
              <div class="product-item__image-wrapper lazy-container">
                <img
                  data-sizes="auto"
                  :data-src="product.images['1']"
                  class="lazyload"
                  :alt="product.title"/>
              </div>
              <div class="product-item__details-wrapper">
                <!-- Title -->
                <span class="product-item__title">
                  {{ product.title }}
                </span>
                <!-- Price -->
                <p class="product-item__price">
                  ${{ product.variants[0].price }}
                </p>
              </div>
            </a>
          </li>
        </ul>
      </section>

      <button type="submit" class="results-all-products btn btn--full" v-show="products_found">
        View All {{ products_found }} Products
      </button>

    </div>

  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  props: [ 'terms' ],

  data () {
    return {
      query         : '',
      suggestions   : [],
      pages         : [],
      products      : [],
      products_found: 0,
      all_empty     : true
    }
  },

  methods: {
    search: debounce(function (e) {
      this.products = []

      // Escape
      if (e.key === 'Escape' || e.keyCode === 27) {
        this.query = ''
        this.all_empty = true
        this.$refs.input.blur()
        this.$parent.toggleSearch()
        return
      }

      // Reset
      if (this.query.length < 2) {
        this.all_empty = true
        return
      }

      // BCSF Endpoint
      let url = new URL('https://services.mybcapps.com/bc-sf-filter/search/suggest')

      // Request options
      let params = {
        shop         : 'haakaa.myshopify.com',
        q            : this.query,
        suggest_types: ['products', 'pages', 'collections'],
        product_limit: 3
      }

      // Create query string from params object
      Object.keys(params).forEach(key => {
        url.searchParams.append(key, params[key])
      })

      // Send request
      fetch(url)
        .then(response => response.json())
        .then(data => {
          this.all_empty = data.all_empty
          this.suggestions = data.suggestions
          this.pages = data.pages
          this.products = data.products
          this.products_found = data.total_product
        })
        .catch(error => {
          console.log('error', error)
        })
    }, 100),

    searchSuggestion (suggestion) {
      this.query = suggestion
      this.$refs.input.value = suggestion
      this.$parent.$el.querySelector('form[action="/search"]').submit()
    }
  }
}
</script>
